/*
Licensed Materials - Property of IBM
694906H
(c) Copyright IBM Corp.  2020 All Rights Reserved

US Government Users Restricted Rights - Use, duplication or disclosure restricted
by GSA ADP Schedule Contract with IBM Corp.
*/
import { gql, useQuery } from '@apollo/client';

export const FETCH_STATEMENTS_PDF_GQL = gql`
  query GetTdUserStatementsPdf($request: PDFStatementsReq!) {
  getTdUserStatementsPdf(request: $request) {
    document
  }
  }
`;

export const useFetchStatementsPDF = (req: any) => {
  const variables = {
    request: {
      docId: req.documentId
    }
  };
  const { data, loading, error } = useQuery(FETCH_STATEMENTS_PDF_GQL, {
    variables,
    fetchPolicy: 'network-only'
  });

  return { data, loading, error };
};
